export const styles = {
	root: {
		display: 'flex',
		flexGrow: 1,
		paddingTop: '32px'
	},
	logout: {
		width: 'calc(100% - 100px)',
		margin: '16px 10px 16px auto'
	},
	title: {},
	header: {
		display: 'flex',
		flexDirection: 'column',
		marginTop: '48px',
		marginRight: '64px',
		marginBottom: '16px'
	},
	paper: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		padding: '8px',
		marginTop: '48px',
		backgroundColor: '#eaebec38'
	},
	block: {
		marginTop: '8px',
		marginBottom: '8px'
	},
	offsetWrapper: {
		width: 'calc(100% - 84px)',
		margin: `16px 0 16px auto`,
		padding: `0px 8px`
	}
};
